import { createSlice } from "@reduxjs/toolkit";
import KurumIcmalHazirlaHastalarResponse from "src/models/Fatura/KurumIcmalleri/KurumIcmalHazirlaHastalarResponse";
import KurumIcmalSorguResponse from "src/models/Fatura/KurumIcmalleri/KurumIcmalSorguResponse";
import VwKurumicmalDTO from "src/models/Fatura/KurumIcmalleri/VwKurumicmalDTO";
import CevirilecekDovizTutarIstek from "src/models/GenelTanimlar/CevirilecekDovizTutarIstek";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { helper } from "src/utils/helper";

export class IIcmalHazirlamaSearch {
    baslangicTarih?: string = helper.datetimeToday();
    bitisTarih?: string = helper.datetimeToday();
    kurum?: string = "";
    servis?: string = "";
    treekey?: string = "";
    kurumGrubu?: number = null;
    faturaIcmalId?: number = null;
    kurumGrubuId?: number = null;
    cevirilecekKur?: number = 1;
}

export class IIcmalSorgulamaSearch {
    baslangicTarih?: string = helper.datetimeToday();
    bitisTarih?: string = helper.datetimeToday();
    kurum?: string = "";
    treekey?: string = "";
    kurumGrubu?: number = null;
    kurumGrubuId?: number = null;
    cevirilecekKur?: number = 1;
}

export interface IFaturaKurumIcmalleriState {
    icmalHazirlamaSearch: IIcmalHazirlamaSearch;
    icmalSorgulamaSearch: IIcmalSorgulamaSearch;
    dovizKurCevirmeIstek: CevirilecekDovizTutarIstek;
    icmalIptalDialog: boolean;
    icmalId: number;
    detayDialog: boolean;
    icmalHazirlamaDetaySearch: IIcmalHazirlamaSearch;
    detaySorgulaDialog: boolean;
    hazirlamaActiveRow?: KurumIcmalSorguResponse;
    sorgulamaActiveRow?: VwKurumicmalDTO;
    muracaatIds?: number[];
}

const FaturaKurumIcmalleriSlice = createSlice<IFaturaKurumIcmalleriState, MapReducerPayloads<IFaturaKurumIcmalleriState, {
    setIcmalHazirlamaSearch: IIcmalHazirlamaSearch;
    setIcmalSorgulamaSearch: IIcmalSorgulamaSearch;
    setDovizKurCevirmeIstek: CevirilecekDovizTutarIstek;
    setIcmalIptalDialog: boolean;
    setIcmalId: number;
    setDetayDialog: boolean;
    setIcmalHazirlamaDetaySearch: IIcmalHazirlamaSearch;
    setDetaySorgulaDialog: boolean;
    setHazirlamaActiveRow?: KurumIcmalSorguResponse;
    setSorgulamaActiveRow?: VwKurumicmalDTO;
    setHastalar?: KurumIcmalHazirlaHastalarResponse;
    setMuracaatIds: number[];
}>>({
    name: "FaturaKurumIcmalleriState",
    initialState: {
        icmalHazirlamaSearch: new IIcmalHazirlamaSearch(),
        icmalSorgulamaSearch: new IIcmalSorgulamaSearch(),
        dovizKurCevirmeIstek: new CevirilecekDovizTutarIstek(),
        icmalIptalDialog: false,
        icmalId: 0,
        detayDialog: false,
        icmalHazirlamaDetaySearch: new IIcmalHazirlamaSearch(),
        detaySorgulaDialog: false,
        hazirlamaActiveRow: new KurumIcmalSorguResponse(),
        sorgulamaActiveRow: new VwKurumicmalDTO(),
        muracaatIds: [],
    },
    reducers: {
        setIcmalHazirlamaSearch: (state, action) => {
            state.icmalHazirlamaSearch = action.payload
        },
        setIcmalSorgulamaSearch: (state, action) => {
            state.icmalSorgulamaSearch = action.payload
        },
        setIcmalIptalDialog: (state, action) => {
            state.icmalIptalDialog = action.payload
        },
        setIcmalId: (state, action) => {
            state.icmalId = action.payload
        },
        setDetayDialog: (state, action) => {
            state.detayDialog = action.payload
        },
        setIcmalHazirlamaDetaySearch: (state, action) => {
            state.icmalHazirlamaDetaySearch = action.payload
        },
        setDetaySorgulaDialog: (state, action) => {
            state.detaySorgulaDialog = action.payload
        },
        setHazirlamaActiveRow: (state, action) => {
            state.hazirlamaActiveRow = action.payload
        },
        setSorgulamaActiveRow: (state, action) => {
            state.sorgulamaActiveRow = action.payload
        },
        setDovizKurCevirmeIstek: (state, action) => {
            state.dovizKurCevirmeIstek = action.payload
        },
        setMuracaatIds: (state, action) => {
            state.muracaatIds = action.payload
        },
    },
});
export default FaturaKurumIcmalleriSlice;